import { Component, Input } from '@angular/core';

/**
 * Profil picture component
 */
@Component({
  selector: 'def-profil-picture',
  templateUrl: './def-profil-picture.component.html',
  styleUrls: ['./def-profil-picture.component.scss'],
})
export class DefProfilPictureComponent {
  @Input() src: string;
  @Input() alt?: string;
  @Input() click?: (args?: any) => void;
  @Input() size?: string;
  @Input() disabled = false;
  onError() {
    this.src = undefined;
  }
}
